export const mapAttemptDescription = (taskDetails: string, stepDetails: string): string => {
  return `${taskDetails}\n\n${stepDetails}`;
};
